<span class="app-tooltip">
  <span #anchor>
    <ng-content select="[customAnchor]"></ng-content>
    <img *ngIf="!customAnchor" class="icon" src="/assets/icons/info.svg" alt="Hover to read tooltip content" />
  </span>
  <span
    *ngIf="showTip"
    #tooltip
    class="app-tooltip__tooltip"
    [ngClass]="{'app-tooltip__below' : placement === 'below',
      'app-tooltip__above': placement === 'above',
      'app-tooltip__above-carousel': placement === 'above-carousel',
      }"
    [style]="getTooltipStyles(tooltip, anchor)"
  >
    <ng-content></ng-content>
  </span>
</span>

